module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    staticClass: "password-validator",
    attrs: {
      "no-gutters": "",
      "align": "start",
      "justify": "start"
    }
  }, [_c('v-col', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-row', {
    staticClass: "password-validator__column",
    attrs: {
      "no-gutters": "",
      "align": "start",
      "justify": "start"
    }
  }, [_c('v-col', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "password-validator__indicator",
    class: {
      'password-validator__indicator--active': _vm.containsLowercase
    }
  }), _vm._v("\n                One lowercase character\n            ")]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "password-validator__indicator",
    class: {
      'password-validator__indicator--active': _vm.containsUppercase
    }
  }), _vm._v("\n                One uppercase character\n            ")])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-row', {
    staticClass: "password-validator__column",
    attrs: {
      "no-gutters": "",
      "column": "",
      "align": "start",
      "justify": "start"
    }
  }, [_c('v-col', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "password-validator__indicator",
    class: {
      'password-validator__indicator--active': _vm.enoughLong
    }
  }), _vm._v("\n                At least 8 characters\n            ")]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "password-validator__indicator",
    class: {
      'password-validator__indicator--active': _vm.containsDigitOrSpecial
    }
  }), _vm._v("\n                One number or special character\n            ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f1b6784","hasScoped":false}!./app/components/password-validator/template.html
// module id = 389
// module chunks = 0